import * as dayjs from 'dayjs';

export const LOCALIZED_DATE_FORMAT = 'LLLL';
export const LOCALIZED_TIME_FORMAT = 'LT';
export const YEAR_FORMAT = 'YYYY';

export const resolveTimezone = (timezone?: string): string => timezone || dayjs.tz.guess() || 'UTC';

export const inTimezone = (date: string | Date, timezone?: string): dayjs.Dayjs =>
	dayjs(date).tz(resolveTimezone(timezone));

class DateService {
	public static formatLocalizedDate(date: string | Date, timezone?: string): string {
		const localizedFormattedDate = inTimezone(date, timezone).format(LOCALIZED_DATE_FORMAT);
		const year = inTimezone(date, timezone).format(YEAR_FORMAT);

		// localized format without year
		return localizedFormattedDate.replace(` ${year}`, '');
	}

	public static formatTime(date: string | Date, timezone?: string): string {
		return inTimezone(date, timezone).format(LOCALIZED_TIME_FORMAT);
	}

	// the end isn't always exposed — a rescheduled order comes back carrying the start of its window only
	public static formatWindow(startDate: string | Date, endDate?: string | Date, timezone?: string): string {
		const start = DateService.formatLocalizedDate(startDate, timezone);

		return endDate ? `${start} - ${DateService.formatTime(endDate, timezone)}` : start;
	}

	public static formatLocalizedDay(date: string | Date, timezone?: string): string {
		return new Intl.DateTimeFormat(dayjs.locale(), {
			weekday: 'short',
			month: 'short',
			day: 'numeric',
			timeZone: resolveTimezone(timezone)
		}).format(dayjs(date).toDate());
	}
}

export default DateService;
